<div class="rolesPage" *ngIf="('ControlRoles' | permissionFilter)">
  <div class="container-component">
        <roles-list class="role-list"></roles-list>
    </div>
</div>
<div *ngIf="!('ControlRoles' | permissionFilter) ">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div>